import { render, staticRenderFns } from "./borderBox.vue?vue&type=template&id=452cc56a&scoped=true&"
import script from "./borderBox.vue?vue&type=script&lang=js&"
export * from "./borderBox.vue?vue&type=script&lang=js&"
import style0 from "./borderBox.vue?vue&type=style&index=0&id=452cc56a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452cc56a",
  null
  
)

export default component.exports